import React from "react";
import axios from "axios";

declare global {
    interface Window {
        Razorpay: any;
    }
}

type CreateOrderResponse = {
    orderId: string;
    dbPaymentId: number;
    amount: number;
};

type RazorpayResponse = {
    razorpay_order_id: string;
    razorpay_payment_id: string;
    razorpay_signature: string;
};

const loadScript = (src: string): Promise<boolean> => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY as string;

const RazorpayTest: React.FC = () => {
    const handlePayment = async () => {
        try {
            // Load Razorpay SDK
            const loaded = await loadScript(
                "https://checkout.razorpay.com/v1/checkout.js"
            );

            if (!loaded) {
                alert("Razorpay SDK failed to load");
                return;
            }

            // Step 1: Create Order
            const { data } = await axios.post<CreateOrderResponse>(
                `${API_BASE}/payment/create-order`,
                {
                    caseID: 1,
                    amount: 500,
                    email: "test@email.com",
                    contact: "9999999999",
                }
            );
            const options = {
                key: RAZORPAY_KEY, // 🔁 Replace with your key
                amount: data.amount * 100,
                currency: "INR",
                name: "Test App",
                description: "Payment Test",
                order_id: data.orderId,

                handler: async (response: RazorpayResponse) => {
                    try {
                        await axios.post(
                            `${API_BASE}/payment/verify`,
                            {
                                paymentDbId: data.dbPaymentId,
                                razorpayOrderId: response.razorpay_order_id,
                                razorpayPaymentId: response.razorpay_payment_id,
                                razorpaySignature: response.razorpay_signature,
                            }
                        );

                        alert("✅ Payment Successful");
                    } catch (err) {
                        console.warn(err);
                        alert("❌ Verification Failed");
                    }
                },

                prefill: {
                    name: "Test User",
                    email: "test@email.com",
                    contact: "9999999999",
                },

                theme: {
                    color: "#3399cc",
                },
            };

            const paymentObject = new window.Razorpay(options);

            paymentObject.on("payment.failed", (response: any) => {
                console.warn(response);
                alert("❌ Payment Failed");
            });

            paymentObject.open();
        } catch (error) {
            console.warn(error);
            alert("Something went wrong");
        }
    };

    return (
        <div style={{ padding: 40 }}>
            <h2>Razorpay Test Payment</h2>
            <button onClick={handlePayment}>
                Pay ₹500
            </button>
        </div>
    );
};

export default RazorpayTest;